import {Api} from '../api/api';
import {addDelegateEventListener} from '../helpers';
import {CommentDeleteButtons} from "./commentDeleteButtons";

class CommentLoader
{
    static initToggleButtons(listContentElement) {
        addDelegateEventListener(
            listContentElement,
            'click',
            '[data-comments-toggle]',
            (buttonElement, event) => {
                event.preventDefault();
                this.toggleComments(buttonElement, listContentElement);
            }
        );
    }

    /**
     * @param {Element} toggleElement
     * @param {Element} listContentElement
     */
    static toggleComments(toggleElement, listContentElement) {
        let toggleId = toggleElement.getAttribute('data-id'),
            existedElement = listContentElement.querySelector(`[data-list="comments"][data-id="${toggleId}"]`),
            existedElements = listContentElement.querySelectorAll(`[data-list="comments"]:not([data-id="${toggleId}"])`);

        Array.from(existedElements).forEach((element) => element.classList.add('is-none'));

        if (!existedElement) {
            return this.loadComments(toggleElement, listContentElement);
        }

        return existedElement.classList.toggle('is-none');
    }

    /**
     * @param {Element} toggleElement
     * @param {Element} listContentElement
     */
    static loadComments(toggleElement, listContentElement) {
        Api.post(toggleElement.getAttribute('data-endpoint'), {}, (response) => {
            if (response.isFailure()) {
                return;
            }

            let relatedElement = toggleElement.closest('[data-list]');
            relatedElement.insertAdjacentHTML('beforeend', response.get('content', ''));

            let entityId = relatedElement.getAttribute('data-id'),
                loadedElement = listContentElement.querySelector(`[data-list="comments"][data-id="${entityId}"]`)

            new CommentDeleteButtons(loadedElement.querySelectorAll('[data-comment="delete"]'));
            this.afterCommentsLoaded(loadedElement);
        });
    }

    /** @param {Element} loadedElement */
    static afterCommentsLoaded(loadedElement) {}
}

export {CommentLoader};
